import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    { q: 'What is the minimum investment amount?', a: 'Minimum investment for Basic Plan is ₹10,000 and for Standard Plan is ₹10,00,000.' },
    { q: 'What are the guaranteed returns?', a: 'We offer guaranteed 60% returns per annum on all investment plans.' },
    { q: 'How are returns paid?', a: 'Returns are credited to your wallet monthly.' },
    { q: 'Can I withdraw early?', a: 'No, early withdrawal is not allowed. The lock-in period is 1 year.' },
    { q: 'How do I make payment?', a: 'You can pay via bank transfer or UPI. Bank details are shown on the investment page.' },
    { q: 'Is my investment safe?', a: 'Yes, your principal amount is fully protected with capital protection guarantee.' }
  ];

  return (
    <>
      <Helmet>
        <title>FAQs - MilkDairy Farm</title>
      </Helmet>
      <div className="container mx-auto px-4 py-16 max-w-3xl">
        <h1 className="text-4xl font-bold text-center mb-4">Frequently Asked Questions</h1>
        <p className="text-gray-600 text-center mb-12">Find answers to common questions about investing with MilkDairy Farm</p>
        
        <div className="space-y-4">
          {faqs.map((faq, idx) => (
            <div key={idx} className="bg-white rounded-xl shadow-md overflow-hidden">
              <button
                className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition"
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
              >
                <span className="font-semibold text-gray-800">{faq.q}</span>
                {openIndex === idx ? <FaChevronUp className="text-green-600" /> : <FaChevronDown className="text-green-600" />}
              </button>
              {openIndex === idx && (
                <div className="px-6 py-4 bg-gray-50 border-t">
                  <p className="text-gray-600">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default FAQ;